var _excluded = ["media"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import ListingModel from '../../models/listing';
import LargeCard from '../../components/large-card';
import OverlayCard from '../../components/overlay-card';
import SmallCard from '../../components/small-card';
import HorizontalSlide from '../../components/horizontal-slide';
import ShadowFrame from '../../components/shadow-frame';
import * as styles from './home-page.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var withShadow = media => Component => props => media.desktop ? ___EmotionJSX(ShadowFrame, null, ___EmotionJSX(Component, props)) : ___EmotionJSX(Component, props);
var getCardComponent = _ref => {
  var media = _ref.media,
    listings = _ref.listings;
  if (media.mobile) {
    return SmallCard;
  }
  if (listings.length === 1) {
    return withShadow(media)(LargeCard);
  }
  return withShadow(media)(props => ___EmotionJSX(OverlayCard, _extends({
    size: listings.length === 2 ? 'large' : 'small'
  }, props)));
};
var HomePage = _ref2 => {
  var media = _ref2.media,
    props = _objectWithoutProperties(_ref2, _excluded);
  var ListingCard = getCardComponent({
    media,
    listings: props.listings
  });
  return ___EmotionJSX("div", {
    css: styles.container
  }, media.mobile && ___EmotionJSX("h2", {
    css: styles.title
  }, props.title), ___EmotionJSX(HorizontalSlide, _extends({
    noScroll: media.desktop,
    component: ListingCard
  }, props)));
};
HomePage.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape(ListingModel)),
  onClick: PropTypes.func,
  title: PropTypes.string,
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    desktop: PropTypes.bool
  })
};
HomePage.defaultProps = {
  listings: [],
  onClick: () => {},
  title: 'Property of the Week',
  media: {}
};
export default withMedia(HomePage);
export { HomePage as BaseHomePage };